import React from 'react';
import {emotionStyled} from '@packages/utilities/styled';

export const DragItemWrapperView = emotionStyled('span')(
  {},
  {
    componentName: 'DragItemWrapper',
  }
);

type DragItemWrapperProps = {
  children: React.ReactNode;
  isDragging?: boolean;
} & React.HTMLAttributes<HTMLSpanElement>;

const DragItemContext = React.createContext<
  Omit<DragItemWrapperProps, 'children'>
>({
  isDragging: false,
});

export const useDragItemContext = () => React.useContext(DragItemContext);

/**
 * A wrapper component that provides context to coordinate drag and drop UI interactions.
 */
export const DragItemWrapper = React.forwardRef<
  HTMLSpanElement,
  DragItemWrapperProps
>(({children, isDragging, ...rest}, ref) => {
  const value = React.useMemo(
    () => ({
      isDragging,
    }),
    [isDragging]
  );

  return (
    <span ref={ref} {...rest}>
      <DragItemContext.Provider value={value}>
        {children}
      </DragItemContext.Provider>
    </span>
  );
});

DragItemWrapper.displayName = 'DragItemWrapper';
DragItemWrapper.toString = DragItemWrapperView.toString;
